import { TileIndex } from "../../types";

export const DONT_GO_UP_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [
    1, 1, 1, 1, 1, 21, 22, 22, 22, 22, 22, 16, 18, 5, 16, 1, 1, 23, 23, 23, 23,
    23, 0, 3, 1,
  ],
  [
    1, 7, 1, 1, 1, 21, 1, 1, 1, 1, 1, 16, 16, 16, 16, 1, 1, 20, 1, 1, 1, 1, 2,
    2, 1,
  ],
  [
    1, 0, 1, 1, 1, 21, 1, 1, 1, 1, 1, 1, 1, 20, 1, 1, 1, 20, 2, 2, 3, 1, 21, 16,
    1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 20, 1, 1, 1, 20, 1, 2, 3, 1, 21, 16,
    1,
  ],
  [
    1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 20, 1, 1, 1, 20, 1, 2, 3, 1, 21, 16,
    1,
  ],
  [
    1, 0, 0, 0, 27, 0, 0, 0, 1, 1, 16, 16, 16, 20, 16, 1, 1, 20, 1, 2, 1, 1, 21,
    16, 1,
  ],
  [
    1, 0, 0, 0, 2, 19, 0, 0, 1, 1, 16, 15, 9, 12, 23, 23, 23, 20, 1, 20, 1, 1,
    21, 16, 1,
  ],
  [
    1, 0, 0, 0, 27, 0, 0, 0, 1, 1, 16, 16, 16, 20, 16, 1, 1, 1, 1, 20, 1, 1, 21,
    1, 1,
  ],
  [
    1, 0, 0, 0, 2, 0, 0, 0, 1, 1, 1, 1, 1, 20, 1, 1, 1, 1, 1, 20, 1, 1, 21, 1,
    1,
  ],
  [
    1, 0, 0, 0, 27, 0, 0, 0, 1, 1, 1, 1, 1, 20, 1, 0, 0, 0, 1, 20, 22, 22, 0, 0,
    1,
  ],
  [
    1, 0, 0, 0, 2, 0, 0, 0, 1, 1, 1, 1, 1, 20, 1, 0, 14, 0, 1, 16, 16, 16, 0, 0,
    1,
  ],
  [
    1, 1, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 0, 0, 0, 1, 16, 16, 16, 16,
    0, 1,
  ],
  [
    1, 21, 21, 21, 21, 21, 21, 21, 1, 1, 1, 1, 1, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    21, 1,
  ],
  [
    1, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 20, 18, 0, 22, 22, 22,
    22, 22, 22, 22, 22, 1,
  ],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
